module.exports = __webpack_public_path__ + "img/connection2.a2587b13.png";